import PrivacyPolicies from '@/components/privacy_policies.vue';
import Support from '@/components/support.vue';
import TermsAndConditions from '@/components/terms_and_conditions.vue';

export default [
  {
    path: '/terms_and_conditions',
    name: 'termsAndConditions',
    component: TermsAndConditions,
    props: true,
  },
  {
    path: '/privacy_policies',
    name: 'privacyPolicies',
    component: PrivacyPolicies,
    props: true,
  },
  {
    path: '/support',
    name: 'support',
    component: Support,
    props: true,
  },
];
